
import React, { useContext } from 'react';
import { userContext } from '../../App';
import ResultDownload from '../../Components/Result/ResultDownload';
import PrintDownload from '../../Utils/PrintDownload';

const ResultCard = () => {
    const [users] = useContext(userContext);
    const students = users?.filter((i) => i?.role?.includes("student"));

    return (
        <div className=''> 
            {/* <PrintDownload /> */}
            <div>
                <ResultDownload 
                    students={students}
                    subject=""
                    classe=""
                />
            </div>
        </div>
    );
};

export default ResultCard;